<script>
import currencyMixin from "../../mixins/CurrencyMixin";

export default {
  name: "CouponView",
  mixins: [currencyMixin],
  props: {
    order: {
      type: Object,
      required: false
    }
  },
  computed: {
    getOrder() {
      return this.order || this.$store.getters.orderSystem.order
    },
    couponCode(){
      return this.getOrder.couponCode;
    },
    discountAmount(){
      return this.getOrder.discountAmount
    },
    discountRate(){
      return this.getOrder.discountRate
    },

  }
}
</script>

<template>

  <div  class="coupon-container">
    <div class="coupon-card">
      <div class="coupon-header">
        <i class="coupon-icon">🎫</i>
        <span class="coupon-label">CUPÓN APLICADO</span>
      </div>

      <div class="coupon-code">
        {{ couponCode }}
      </div>

      <div class="discount-info">
        <div v-if="discountAmount" class="discount-amount">
          <span class="discount-label">Descuento:</span>
          <span class="discount-value">-{{ currencyFormat(discountAmount) }}</span>
        </div>

        <div v-if="discountRate" class="discount-rate">
          <span class="discount-label">Descuento:</span>
          <span class="discount-value">-{{ discountRate }}%</span>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.coupon-container {
  margin: 16px 0;
}

.coupon-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 16px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
}

.coupon-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.coupon-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.coupon-icon {
  font-size: 20px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.coupon-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0.9;
}

.coupon-code {
  font-size: 18px;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 12px;
  border-radius: 6px;
  border: 2px dashed rgba(255, 255, 255, 0.3);
  text-align: center;
  margin-bottom: 12px;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
}

.discount-info {
  position: relative;
  z-index: 1;
}

.discount-amount,
.discount-rate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(10px);
}

.discount-label {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
}

.discount-value {
  font-size: 16px;
  font-weight: 700;
  color: #4ade80;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Variante más minimalista si prefieres algo más sutil */
.coupon-card.minimal {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  color: #334155;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.coupon-card.minimal .coupon-code {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.coupon-card.minimal .discount-amount,
.coupon-card.minimal .discount-rate {
  background: #f1f5f9;
}

.coupon-card.minimal .discount-value {
  color: #059669;
}

/* Responsive */
@media (max-width: 480px) {
  .coupon-card {
    padding: 12px;
  }

  .coupon-code {
    font-size: 16px;
    letter-spacing: 1px;
  }

  .discount-label,
  .discount-value {
    font-size: 13px;
  }
}
</style>
